<template>
  <v-container fluid class="pa-0">
    <v-row class="ma-0" dense>
      <v-col class="pa-0">

        <v-row class="ma-0 mt-3">
          <v-col class="pa-0">
            <v-card>

              <template v-if="!railTimetables || railTimetables.length === 0">
                <v-card-text class="d-flex align-center justify-center py-6">
                  <v-icon color="warning" class="mr-2" size="20">mdi-alert</v-icon>
                  <span class="font-weight-medium warning--text">{{ $t('label.noTrackingInfo') }}</span>
                </v-card-text>
              </template>

              <template v-else-if="railTimetables.length === 1">
                <RailTimetableDetail :timetable="railTimetables[0]" />
              </template>

              <template v-else>
                <v-tabs
                    v-model="railTab"
                    background-color="accent"
                    height="2rem"
                    grow
                >
                  <v-tab
                      v-for="(timetable) in railTimetables"
                      :key="timetable.messageId"
                  >
                    <v-icon small class="mr-1">mdi-train</v-icon>
                    {{ timetable.messageId }}
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="railTab">
                  <v-tab-item
                      v-for="(timetable) in railTimetables"
                      :key="timetable.messageId"
                  >
                    <RailTimetableDetail :timetable="timetable" />
                  </v-tab-item>
                </v-tabs-items>
              </template>

            </v-card>
          </v-col>
        </v-row>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RailTimetableDetail from '@/components/elements/pratica/RailTimetableDetail.vue'
import {praticheService} from "../../../services/pratiche.service";

export default {
  name: 'PraticaTrasportoPrincipaleRail',
  props: ['pratica', 'imballi'],
  components: { RailTimetableDetail },
  data() {
    return {
      railTab: 0,
      railTimetables: [],
    }
  },
  methods: {
    async init() {
      await this.getRailTracking()
    },
    async getRailTracking() {
      try {
        const response = await praticheService.getRailTracking(this.pratica.id)
        this.railTimetables = response || []
      } catch (e) {
        console.error('Failed to load rail tracking', e)
        this.railTimetables = []
      }
    },
  },
  created() {
    this.init()
  },
}
</script>

<style scoped>
.v-simple-checkbox .theme--light.v-icon {
  color: #005eb8 !important;
}
</style>
